import React from 'react';
import { Phone, MapPin, Package, Home } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    number: 1,
    title: 'Contáctanos y cotiza',
    description: 'Escríbenos con los detalles de tu envío',
    icon: Phone
  }, {
    number: 2,
    title: 'Envía a nuestra dirección',
    description: '7763 NW 64 St, Miami, FL 33166',
    icon: MapPin
  }, {
    number: 3,
    title: 'Consolidamos tu carga',
    description: 'Preparamos y aseguramos tu paquete',
    icon: Package
  }, {
    number: 4,
    title: 'Entrega en Venezuela',
    description: 'Recibe en Barquisimeto y más ciudades',
    icon: Home
  }];
  return <section id="como-funciona" className="py-16 md:py-24 bg-white relative overflow-hidden" data-id="element-87">
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-88">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-[#1B2B5E]" data-id="element-89">
          ¿Cómo funciona?
        </h2>

        <div className="relative" data-id="element-90">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gray-200 border-t-2 border-dashed border-gray-300 z-0" data-id="element-91"></div>

          {/* Connecting Line (Mobile) */}
          <div className="md:hidden absolute top-0 bottom-0 left-8 w-0.5 bg-gray-200 border-l-2 border-dashed border-gray-300 z-0" data-id="element-92"></div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6" data-id="element-93">
            {steps.map((step, index) => <div key={index} className="relative z-10 flex md:flex-col items-start md:items-center gap-6 md:gap-4" data-id="element-94">
                <div className="flex-shrink-0 w-16 h-16 rounded-full bg-[#F5A623] text-[#1B2B5E] flex items-center justify-center font-bold text-2xl shadow-lg border-4 border-white" data-id="element-95">
                  {step.number}
                </div>

                <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex-1 md:w-full text-left md:text-center relative group hover:shadow-xl transition-shadow" data-id="element-96">
                  <div className="absolute -top-4 -right-4 w-12 h-12 bg-[#1B2B5E] rounded-full flex items-center justify-center text-white shadow-md transform group-hover:scale-110 transition-transform hidden md:flex" data-id="element-97">
                    <step.icon size={20} data-id="element-98" />
                  </div>

                  <div className="md:hidden mb-4 text-[#1B2B5E]" data-id="element-99">
                    <step.icon size={28} data-id="element-100" />
                  </div>

                  <h3 className="text-lg font-bold text-[#1B2B5E] mb-2" data-id="element-101">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-102">{step.description}</p>

                  {index === 0 && <div className="mt-4 rounded-lg overflow-hidden h-24" data-id="element-103">
                      <img src="https://cdn.magicpatterns.com/uploads/u3YCWrjZUoA6HnR5Yk9Tyn/Contactanos_y_cotiza.jpg" alt="Contáctanos y cotiza" className="w-full h-full object-cover" data-id="element-104" />
                    </div>}

                  {index === 1 && <div className="mt-4 rounded-lg overflow-hidden h-24" data-id="element-105">
                      <img src="https://cdn.magicpatterns.com/uploads/swKLADSEUJKZGdsii9g5Pu/Direcc_Miami.jpg" alt="7763 NW 64 St, Miami, FL 33166" className="w-full h-full object-cover" data-id="element-106" />
                    </div>}

                  {index === 2 && <div className="mt-4 rounded-lg overflow-hidden h-24" data-id="element-107">
                      <img src="https://cdn.magicpatterns.com/uploads/hqKxcM9ey6CaY2niZJuQft/Concepto_consolidado.jpg" alt="Consolidación de carga" className="w-full h-full object-cover" data-id="element-108" />
                    </div>}

                  {index === 3 && <div className="mt-4 rounded-lg overflow-hidden h-24" data-id="element-109">
                      <img src="https://cdn.magicpatterns.com/uploads/wdeJhwghkGpZnvg4UCgbai/Miami_-_Barquisimeto.jpg" alt="Entrega en Venezuela" className="w-full h-full object-cover" data-id="element-110" />
                    </div>}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}